// export const backendUrl = "http://localhost:8083"; //dev
// export const backendUrl = "https://usgidocxplorapi.universalsompo.com"; //sompo
// export const backendUrl = "http://docxplor-api.magmainsurance.com"; //magma
// export const backendUrl = "https://api.stage.docxplor.com"; //stage
export const backendUrl = "https://api.docxplor.com"; //prod
